import type { ButtonHTMLAttributes, ReactNode } from "react";
import { FiChevronDown } from "react-icons/fi";

export interface PillButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: ReactNode;
  children: ReactNode;
  /** Muestra la flecha de desplegable a la derecha del texto. */
  chevron?: boolean;
  /** Contador en píldora amarilla; solo se muestra cuando es mayor que 0. */
  count?: number;
}

/** Botón pill de barra de herramientas: icono, texto, flecha y contador opcionales. Reenvía las props del botón (aria-expanded, onClick…). */
export function PillButton({ icon, children, chevron = false, count, className = "", type = "button", ...buttonProps }: PillButtonProps) {
  return (
    <button
      type={type}
      className={`inline-flex h-13 flex-none items-center gap-2 whitespace-nowrap rounded-[var(--ds-radius-md)] border-[1.5px] border-solid border-[var(--ds-ink)] bg-[var(--app-surface)] px-4 text-[15px] font-medium leading-none text-[var(--ds-ink)] ${className}`}
      {...buttonProps}
    >
      {icon ? <span aria-hidden="true" className="flex">{icon}</span> : null}
      {children}
      {count !== undefined && count > 0 ? (
        <span aria-hidden="true" className="inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-[var(--ds-card-sun)] px-2 text-xs font-medium leading-none text-[var(--ds-on-card)]">
          {count}
        </span>
      ) : null}
      {chevron && <FiChevronDown aria-hidden="true" className="h-4 w-4" />}
    </button>
  );
}
